import findKeyPathOfNode from "./findKeyPathOfNode";

export default (tree, nodeIds) => {
  return tree.withMutations(t => {
    // Iterate through the items, grab their tree, and then remove them
    nodeIds.forEach(id => {
      const keypath = findKeyPathOfNode(t, id);
      if (keypath && keypath.length > 0) {
        t.deleteIn(keypath);
      }
    });
  });
};
